export enum ApplicationEvents {
  NAVIGATE_TO_NEXT_PAGE = 'ApplicationEvents:NAVIGATE_TO_NEXT_PAGE',
  FETCH_FLOW_IDS_AND_NAVIGATE = 'ApplicationEvents:FETCH_FLOW_IDS_AND_NAVIGATE'
}
